import { Flex, Text } from "@amzn/storm-ui";
import React from "react";
import styled from "styled-components";
import { useStore } from "zustand";

import { FeatureFlagsStore } from "../../../store/featureFlags";
import { discoveryFilterStore } from "../../../store/filters";
import { IHubContentProvider } from "../../../types/providers";

import { SearchSortDropdown } from "./SearchSortDropdown";
import { UnifiedSearchSortDropdown } from "./UnifiedSearchSortDropdown";

const StyledInfoPanel = styled(Flex)`
    padding: ${({ theme }) => theme.spacing.xsmall.default};
    align-items: center;
`;

export const InfoPanel: React.FunctionComponent<{
    insightCount: number;
    showSearchSortDropdown: boolean;
}> = ({ insightCount, showSearchSortDropdown }) => {
    const [useUnifiedSearch] = useStore(FeatureFlagsStore, (state) => [
        state.unifiedSearch,
    ]);

    const iHubContentProvider = useStore(discoveryFilterStore, (state) =>
        state.getContentSubTypeProvider(),
    );

    return (
        <StyledInfoPanel justifyContent="space-between">
            <Text>
                <strong>{insightCount} total</strong>
            </Text>
            {showSearchSortDropdown && useUnifiedSearch && (
                <UnifiedSearchSortDropdown />
            )}
            {showSearchSortDropdown &&
                !useUnifiedSearch &&
                iHubContentProvider ===
                    IHubContentProvider.MARKETING_NARRATIVES && (
                    <SearchSortDropdown />
                )}
        </StyledInfoPanel>
    );
};
